/*global define, console, window, HTMLImageElement, Promise*/

(function (root, factory) {
    "use strict";
    if (typeof define === 'function' && define.amd) {
        define("TextWithSlidingImages", ["jquery", "Behaviors"], factory);
    } else {
        root.TextWithSlidingImages = factory(root.jQuery, root.Behaviors);
    }
}(this, function ($, Behaviors) {
    "use strict";
    var module = {};
    var moduleInstanceId;
    function TextWithSlidingImages(target) {

        //handle multiple instances in one page
        this.moduleInstanceId = '.fl-node-' + target.getAttribute( 'data-text-with-sliding-images' );
        
        Behaviors.init(TextWithSlidingImages, this, arguments);

        if( $( this.moduleInstanceId + ' ' + TextWithSlidingImages.ELEMENTS.slickWrapper).length ){

            $( this.moduleInstanceId + ' ' + TextWithSlidingImages.ELEMENTS.slickWrapper).slick( 
                {
                    prevArrow: this.moduleInstanceId + " .TextWithSlidingImages-navigation .slide-prev",
                    nextArrow: this.moduleInstanceId + " .TextWithSlidingImages-navigation .slide-next",
                    autoplay: false,
                    variableWidth: true
                }
             );

        }

    };

    Behaviors.inherit(TextWithSlidingImages, Behaviors.Behavior);

    TextWithSlidingImages.QUERY = "[data-text-with-sliding-images]";

    Behaviors.register_behavior(TextWithSlidingImages);

    TextWithSlidingImages.ELEMENTS = {
        slickWrapper: ".TextWithSlidingImages-wrapper .slide-items",
        navContainer: ".TextWithSlidingImages-navigation"
    };

    module.TextWithSlidingImages = TextWithSlidingImages;

    return module;
}));
